import axiosClient, {
  getApiErrorMessage,
  getApiValidationErrors,
} from './axiosClient';

function enrichError(error) {
  error.userMessage = getApiErrorMessage(error);
  error.validationErrors = getApiValidationErrors(error);
  return error;
}

export async function startFreeTrial(email, locale) {
  try {
    const response = await axiosClient.post('/public/free-trial/start', {
      email,
      locale,
    });

    return response.data?.data || {};
  } catch (error) {
    throw enrichError(error);
  }
}

export async function verifyFreeTrialEmail(payload) {
  try {
    const response = await axiosClient.post(
      '/public/free-trial/verify-email',
      payload,
    );

    return response.data?.data || {};
  } catch (error) {
    throw enrichError(error);
  }
}

export async function submitFreeTrialRequest(payload) {
  try {
    const response = await axiosClient.post(
      '/public/free-trial/submit',
      payload,
    );

    return response.data?.data || {};
  } catch (error) {
    throw enrichError(error);
  }
}

export async function getFreeTrialRequests(params = {}) {
  try {
    const response = await axiosClient.get('/free-trial-requests', {
      params,
    });

    return response.data?.data || {
      items: [],
      pagination: {},
    };
  } catch (error) {
    throw enrichError(error);
  }
}

export async function getFreeTrialRequest(id) {
  try {
    const response = await axiosClient.get(`/free-trial-requests/${id}`);
    return response.data?.data || null;
  } catch (error) {
    throw enrichError(error);
  }
}

export async function reviewFreeTrialRequest(id, decision, note = '') {
  try {
    const response = await axiosClient.patch(
      `/free-trial-requests/${id}/decision`,
      {
        decision,
        note: note || null,
      },
    );

    return response.data?.data || {};
  } catch (error) {
    throw enrichError(error);
  }
}

export async function activateFreeTrialRequest(id) {
  try {
    const response = await axiosClient.post(
      `/free-trial-requests/${id}/activate`,
    );

    return response.data?.data || {};
  } catch (error) {
    throw enrichError(error);
  }
}

export async function setFreeTrialActivation(id, active) {
  try {
    const response = await axiosClient.patch(
      `/free-trial-requests/${id}/activation`,
      { active },
    );

    return response.data?.data || {};
  } catch (error) {
    throw enrichError(error);
  }
}

export async function sendFreeTrialAccountDetails(id) {
  try {
    const response = await axiosClient.post(
      `/free-trial-requests/${id}/send-account-details`,
    );

    return response.data?.data || {};
  } catch (error) {
    throw enrichError(error);
  }
}
